import { render, staticRenderFns } from "./ContractFormBtns.vue?vue&type=template&id=18c2d12b&"
import script from "./ContractFormBtns.vue?vue&type=script&lang=js&"
export * from "./ContractFormBtns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports